<script setup>
import { ref, onMounted } from 'vue'

const isMounted = ref(false)

onMounted(() => {
  isMounted.value = true
})
</script>

<template>
  <Teleport v-if="isMounted" to="#timer">
    <slot name="timer"></slot>
  </Teleport>
  <div class="layout-nav">
    <slot name="nav"></slot>
  </div>
  <div class="layout-content">
    <slot name="content"></slot>
  </div>
  <div class="layout-gallery">
    <slot name="gallery"></slot>
  </div>
</template>

<style scoped>
.layout-nav {
  position: absolute;
  top: 0;
  left: 0;
  z-index: var(--layer-2);
}

.layout-content {
  position: relative;
  width: var(--app-width);
  height: 1555px;
}

.layout-gallery {
  position: relative;
  width: var(--app-width);
  height: 365px;
}
</style>
